<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { errorCommonConfig } from './configs/common'
import ErrorPageNovelyn from './components/ErrorPage.novelyn.vue'
import { brand } from '@/config/brands'
import { ERROR_PAGE_LEVEL } from '@/constants'

withDefaults(
  defineProps<{
    level: ERROR_PAGE_LEVEL
  }>()
  , {
    level: ERROR_PAGE_LEVEL.DEFAULT,
  },
)

const config = errorCommonConfig

const route = useRoute()
const message = ref('')
onMounted(() => {
  try {
    if (brand === 'novelyn') {
      const rawMessage = route.query.message as string | undefined
      message.value = rawMessage ? window.decodeURIComponent(rawMessage) : config.texts.defaultMessage
    }
    else {
      message.value = window.decodeURIComponent(route.query.message as string) || config.texts.defaultMessage
    }
  }
  catch {}
})

const router = useRouter()
function onRetry() {
  window.location.replace(window.decodeURIComponent(route.query.redirect as string ?? '/'))
}

function onHome() {
  router.push({
    name: 'home',
  })
}
</script>

<template>
  <ErrorPageNovelyn
    v-if="brand === 'novelyn'"
    :level="level"
    :message="message"
    :retry-text="config.texts.retry"
    :home-text="config.texts.home"
    :on-retry="onRetry"
    :on-home="onHome"
  />
  <div v-else>
    <BasicNavbar v-if="level === ERROR_PAGE_LEVEL.DEFAULT" class="color-n-text-2" />
    <div class="py-4 px-8 flex flex-col items-center justify-center h-100dvh bg-n-bg-global">
      <img class="w-100px" src="@/assets/cover-error.png">

      <template v-if="level === ERROR_PAGE_LEVEL.DEFAULT">
        <p class="mt-2 text-12px text-center text-n-text-3">
          {{ message }}
        </p>

        <div class="flex">
          <button
            class="mt-4 px-6 py-1 text-n-primary border-n-primary border-1 border-solid rounded-full"
            @click="onRetry"
          >
            {{ config.texts.retry }}
          </button>

          <button
            class="mt-4 ml-2 px-6 py-1 text-n-primary border-n-primary border-1 border-solid rounded-full"
            @click="onHome"
          >
            {{ config.texts.home }}
          </button>
        </div>
      </template>
      <template v-else-if="level === ERROR_PAGE_LEVEL.FATAL">
        <p class="mt-4 w-full text-center text-n-text-2">
          {{ message }}
        </p>
      </template>
    </div>
  </div>
</template>
